import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Events } from '../event-group/events';
import { LoadingService } from '../loading.service';
import { collection, where, onSnapshot, Unsubscribe, query, doc } from '@firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class StatsService {

  authorsHelped = 0
  booksSold = 0
  titlesPublished = 0
  yearsExperience = 0

  keepFocus = false
  editingStats = false
  db = this.firestore.firestore
  statsListener?: Unsubscribe

  constructor(public firestore: AngularFirestore, private storage: AngularFireStorage, public loadingService: LoadingService) { this.watchStats() }

  watchStats() {
    if (this.statsListener != null) {
      return
    }

    this.statsListener = onSnapshot(doc(this.db, "facts", "updatedFacts"), (doc) => {
      const data = doc.data()!!
      this.authorsHelped = data["authorsHelped"]
      this.booksSold = data["booksSold"]
      this.titlesPublished = data["titlesPublished"]
      this.yearsExperience = data["yearsExperience"]
    });
  }


  editStatsCancelled() {
    this.keepFocus = false
  }

  updateStats(stats: Object) {
    const statsDoc = this.db.collection("facts").doc("updatedFacts");
    const loadingKey = "stats"
    this.loadingService.addLoadingKey(loadingKey)

    statsDoc.update(stats) 
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.editingStats = false
      alert("Author Removed successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  } 
}
